import { assessmentSummaryConstants } from '../../_constants';
import { assessmentSummaryService } from '../../_services';

export const getBatchAction = {
    getBatchHandler
};

function getBatchHandler(selId,orgId, callback) {
    return dispatch => {
        dispatch(request());
        assessmentSummaryService.getBatchHandler(selId,orgId)
            .then(
                getBatch => {
                    dispatch(success(getBatch));
                    if(callback) {
                        callback(getBatch)
                    }
                },
                error => {
                    dispatch(failure(error));
                    if(callback) {
                        callback(error)
                    }
                }
            );
    };

    function request() { return { type: assessmentSummaryConstants.REQUEST_BATCH} }
    function success(getBatch) { return { type: assessmentSummaryConstants.RECEIVE_BATCH, getBatch } }
    function failure(error) { return { type: assessmentSummaryConstants.BATCH_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/AssessmentSummary/getBatch.action.js